import {defineStore} from 'pinia'
import {ref} from 'vue'

export interface CustomAction {
    /** Текст, який зʼявиться на кнопці */
    actionName: string;
    /** Обробник кліка; може бути синхр. або async */
    onClick?: (event: PointerEvent) => void | Promise<void>;
}

export const useSnackbarStore = defineStore('SnackbarStore', () => {
    const isOpen = ref(false)
    const message = ref('')
    const status = ref('error')
    const customActions = ref<CustomAction[]>([])

    const showSnackbar = (msg: string, st: string, optionalActions?: CustomAction[]) => {
        if (!['error', 'success', 'info', 'warning', 'info', 'warning'].includes(st.toLowerCase())) {
            console.error("Wrong status of Snackbar Notification", msg, st)
        }

        customActions.value.splice(0, customActions.value.length) // Clear custom actions
        message.value = msg
        status.value = st
        isOpen.value = true

        if (optionalActions) {
            customActions.value.push(...optionalActions) // Spread the array into customActions
        }

        if (status.value.toLowerCase() === 'success') {
            setTimeout(() => {
                closeSnackbar()
            }, 2500)
        }
    }

    const showErrorSnackbar = (msg: string, optionalActions?: CustomAction[]) => {
        showSnackbar(msg, 'error', optionalActions)
    }

    function closeSnackbar() {
        isOpen.value = false
        customActions.value.splice(0, customActions.value.length) // Clear custom actions
    }

    return {
        isOpen,
        message,
        status,
        showSnackbar,
        showErrorSnackbar,
        closeSnackbar,
        customActions
    }
})